import { createClient } from "@hyper-fetch/core";

export const githubClient = createClient({ url: "https://api.github.com" });
